import { Injectable } from '@angular/core';
import { Explainer, ExplainerContent } from 'app/shared/explainer-dialog/explainer-dialog-content';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExplainerDialogService {
  public explainerBS = new BehaviorSubject<Explainer>(undefined);
  public explainerContentBS = new BehaviorSubject<ExplainerContent>(undefined);

  constructor() {}

  public setContentExpainer(content: ExplainerContent, event?): void {
    if (content) {
      this.explainerContentBS.next(content);
    } else {
      this.closeExplainer();
    }
    if (event) event.preventDefault();
  }

  public closeExplainer(): void {
    this.explainerBS.next({
      top: 0,
      left: 0,
      isExisted: false,
      menuIsOpen: false,
    });
  }
}
